import { Module } from 'vuex';
import { BILLS_SET_BILLS } from '@/modules/invoicing/store/bills.mutations';
import { BILLS_FETCH_ALL } from '@/modules/invoicing/store/bills.actions';
import { GET_BILL_LIST } from '@/modules/invoicing/store/bills.getters';
import APIService from '@/modules/shared/shared/domain/api';
const apiService = new APIService();
const bills: Module<any, any> = {
    namespaced: true,
    state: {
        bills: [],
    },
    getters: {
        [GET_BILL_LIST](state): { id: number; date: Date; name: string }[] {
            try {
                // {id del cliente}-{yyyy}-{mm}-{FA o NC}-{num_factura/num_nota_credito}-{correlativo}
                return state.bills.map(i => {
                    const name = i.name.split('-');
                    const year = name[1];
                    const month = name[2];
                    const date = new Date(year + '-' + month + '-02');
                    const billId = name[4];
                    let id = parseInt(billId);
                    return {
                        id,
                        date,
                        name: i.name,
                    };
                });
            } catch (e) {
                return [];
            }
        },
    },
    mutations: {
        [BILLS_SET_BILLS](state, bills) {
            state.bills = bills;
        },
    },
    actions: {
        async [BILLS_FETCH_ALL]({ state, commit }, id): Promise<boolean> {
            try {
                state.bills = [];
                const bills = (await apiService.getAllBills({ customerid: id })).data;
                commit(BILLS_SET_BILLS, bills);
                return true;
            } catch (e) {
                return false;
            }
        },
    },
};

export default bills;
